<bp-hl-area-container name="Aufnahme">
	<div class="touch-form">
		<div class="form-row">
			<div class="form-label-cell">Punktart</div>
			<div class="form-input-cell">
				<wd-typeahead [(model)]="data.type" name="PunktartMitProtokoll"></wd-typeahead>
			</div>
			<div class="form-label-cell">Nummer <wd-help name="Nummer"></wd-help></div>
			<div class="form-input-cell multi">
				<wd-text-input name="Nummer" [(model)]="data.header.nummer" nonEmpty (modified)="onNummerChanged($event)"></wd-text-input>
				<button *ngIf="canGenerateNummer()" type="button" class="btn btn-info btn-sm" (click)="generateNummer()" title="Punktnummer aus FA-Revier-Nr-Jahr generieren"><bi name="hash"></bi> Generieren</button>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Datum</div>
			<div class="form-input-cell">
				<wd-date-input *ngIf="canSeePersonalData()" name="Aufnahmedatum" [(model)]="data.header.aufnahme.datum" nonEmpty></wd-date-input>
				<span *ngIf="!canSeePersonalData()" class="masked-value">–</span>
			</div>
			<div class="form-label-cell">Kartierer</div>
			<div class="form-input-cell">
				<wd-text-input *ngIf="canSeePersonalData()" name="Kartierer" [(model)]="data.header.aufnahme.kartierer" nonEmpty></wd-text-input>
				<span *ngIf="!canSeePersonalData()" class="masked-value">–</span>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Labornummer</div>
			<div class="form-input-cell">
				<wd-text-input name="Labornummer" [(model)]="data.header.labornummer"></wd-text-input>
			</div>
			<div class="form-label-cell">Laborstatus</div>
			<div class="form-input-cell">
				<wd-list-input name="Status Laboranalyse" [(model)]="data.header.statusLaboranalyse" options="|noch nicht ausgewertet|Ergebnis liegt vor"></wd-list-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Projekt</div>
			<div class="form-input-cell" style="grid-column: span 3;">
				<span class="readonly-value">{{ projekteString() }}</span>
			</div>
		</div>
	</div>
</bp-hl-area-container>
